import PropTypes from 'prop-types'
import React, { Component } from "react"
import {
  Alert,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Label,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap"

import classnames from "classnames"

//SweetAlert
import SweetAlert from "react-bootstrap-sweetalert"

// availity-reactstrap-validation
import { AvField, AvForm } from "availity-reactstrap-validation"

// Redux
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

import { countries } from "../../common/data/country"

import { isEmpty, isEqual } from "lodash"

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb"

import { EDIT_PROFILE, GET_PROFILE } from "../../store/auth/profile/actionTypes"

import { RESULT_OK, RESULT_ERROR } from "../../store/baseActionTypes"

// actions
import { editProfile, clearActionResult, getProfile } from "../../store/actions"

import PageLoader from 'pages/Common/PageLoader'

class UserProfile extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: "1",
      firstName: "",
      lastName: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      country: "",
      countryCode: "",
      mobile: "",
      email: "",
      aadharNumber: "",
      passportNumber: "",

      username: "",
      password: "",
      newPassword: "",
      confirmPassword: "",
      // astro user attributes ends

      actionResult: {},
      actionResultChanged: false,
      loading: false,
      updateDetail: "personal",
      leftComponent: false
    }
    this.toggleTab = this.toggleTab.bind(this)

    // handleValidSubmit
    this.handleCountry = this.handleCountry.bind(this)
    this.handleValidPersonalUpdate = this.handleValidPersonalUpdate.bind(this)
    this.handleValidLoginUpdate = this.handleValidLoginUpdate.bind(this)
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      })
    }
  }

  handleCountry(event) {
    let country = JSON.parse(event.target.value);
    this.setState({
      country: country.name,
      countryCode: country.pcode
    })
  }

  componentDidMount() {
    this.props.getProfile()
  }

  // componentWillUnmount() {
  //   console.log("componentWillUnmount->entered");
  //   this.setState({
  //     leftComponent: true
  //   })
  // }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState, ss) {
    console.log("componentDidUpdate->entered");
    const { astroUser, actionResult, loading } = this.props
    if (!isEqual(prevProps.loading, loading)) {
      this.setState({ loading: loading })
    }

    if ((!isEmpty(actionResult) && !isEqual(prevProps.actionResult, actionResult))
      || (!isEqual(prevProps.astroUser, astroUser)) || this.state.leftComponent) {
      console.log("componentDidUpdate->actionResultChanged");
      console.log("astro user", astroUser)
      const { firstName,
        lastName,
        address1,
        address2,
        city,
        state,
        country,
        countryCode,
        aadharNumber,
        passportNumber,
        mobile,
        email,
        username } = astroUser

      this.setState({
        actionResult,
        actionResultChanged: true,
        firstName,
        lastName,
        address1,
        address2,
        city,
        state,
        country,
        countryCode,
        aadharNumber: (aadharNumber === '0' || aadharNumber == undefined) ? "" : aadharNumber,
        passportNumber: (passportNumber == null || passportNumber == undefined) ? "" : passportNumber,
        mobile,
        email,
        username,
        leftComponent: false,
      })
    }
  }

  handleUpdateResult = () => {
    let { actionResult, actionResultChanged } = this.state
    console.log("handleUpdateResult :::::::")
    console.log("actionResult :::::::", actionResult)
    console.log("actionResultChanged :::::::", actionResultChanged)
    if (actionResultChanged === true && !isEmpty(actionResult)) {
      console.log("renderActionResultDlg->actionResultChanged");
      let error = false
      let success = false
      let title = ''
      switch (actionResult.action) {
        case EDIT_PROFILE:
          if (actionResult.result === RESULT_OK) {
            success = true
            error = !success
            if (this.state.updateDetail === "personal")
              title = "Profile updation successfull"
            else if (this.state.updateDetail === "login")
              title = "Password updation successfull"
          } else if (actionResult.result === RESULT_ERROR) {
            error = true
            success = !error
            if (this.state.updateDetail === "personal")
              title = "Profile updation failed"
            else if (this.state.updateDetail === "login")
              title = "Password updation failed"
          }
          break;
      }
      return <SweetAlert
        error={error}
        success={success}
        title={title}
        onConfirm={() => {
          this.setState({ actionResultChanged: false })
          this.props.clearActionResult()
          this.props.getProfile()
        }}
      >
      </SweetAlert>
    }
    return null;
  }

  handleValidPersonalUpdate() {
    console.log("inside handleValidPersonalUpdate ::::")
    this.setState({ updateDetail: "personal" })
    const astroUser = {
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      address1: this.state.address1,
      address2: this.state.address2,
      city: this.state.city,
      state: this.state.state,
      country: this.state.country,
      countryCode: this.state.countryCode,
      aadharNumber: this.state.aadharNumber,
      passportNumber: this.state.passportNumber,
      mobile: this.state.mobile,
      email: this.state.email,
      updateDetail: "personal"
    }
    console.log("edit profile astroUser={}", astroUser)
    this.props.editProfile(astroUser)
  }

  handleValidLoginUpdate() {
    console.log("inside handleValidLoginUpdate ::::")
    this.setState({ updateDetail: "login" })
    let astroUser = {
      password: this.state.password,
      newPassword: this.state.newPassword,
      updateDetail: "login"
    }
    console.log("edit profile astroUser={}", astroUser)
    this.props.editProfile(astroUser)
  }

  renderLoader = () => {
    console.log("render loader started :::::::", this.state.loading)
    if (this.state.loading === true) {
      return (
        <PageLoader loaderMsg="Updating your profile..." />
      )
    }
    return null
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          {this.renderLoader()}
          {this.handleUpdateResult()}
          <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumb title="" breadcrumbItem="Profile" />
            <div className="checkout-tabs">
              <Row>
                <Col lg="2" sm="3">
                  <Nav className="flex-column" pills>
                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: this.state.activeTab === "1",
                        })}
                        onClick={() => {
                          this.toggleTab("1")
                        }}
                      >
                        <i className="bx bx-user d-block check-nav-icon mt-4 mb-2" />
                        <p className="font-weight-bold mb-4">Personal details</p>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: this.state.activeTab === "2",
                        })}
                        onClick={() => {
                          this.toggleTab("2")
                        }}
                      >
                        <i className="bx bxs-key  d-block check-nav-icon mt-4 mb-2" />
                        <p className="font-weight-bold mb-4">Login details</p>
                      </NavLink>
                    </NavItem>
                  </Nav>
                </Col>
                <Col lg="10" sm="9">
                  <Card>
                    <CardBody>
                      <TabContent activeTab={this.state.activeTab}>
                        <TabPane tabId="1">
                          <AvForm
                            className="needs-validation"
                            onValidSubmit={this.handleValidPersonalUpdate}
                          >
                            <div>
                              <Alert color="info" className="mb-4sss" role="alert">
                                <h5 className="font-size-16 me-3">Personal details</h5>
                              </Alert>
                            </div>

                            <Row>
                              <Col>
                                <div className="mb-3 form-group">
                                  <AvField
                                    name="firstName"
                                    label="First name"
                                    className="form-control"
                                    placeholder="First name"
                                    type="text"
                                    validate={{
                                      required: { value: true, errorMessage: 'Please enter a first name' },
                                      // pattern: { value: '^[a-zA-Z]+(([,. -][a-zA-Z ])?[a-zA-Z]*)*$', errorMessage: 'First name can only contain aphanumeric and space' },
                                      pattern: { value: '^(?!\d+$)(?:[a-zA-Z0-9][a-zA-Z0-9 ]*)?$', errorMessage: 'First name can only contain aphanumeric and space' },
                                      minLength: { value: 3, errorMessage: 'First name must have minimum 3 characters.' },
                                      maxLength: { value: 30, errorMessage: 'First name must not be greater than 30 characters.' }
                                    }}
                                    value={this.state.firstName}
                                    onChange={(event, value) => { this.setState({ firstName: value }) }}
                                  />
                                </div>
                              </Col>

                              <Col>
                                <div className="mb-3 form-group">
                                  <AvField
                                    name="lastName"
                                    label="Last name"
                                    className="form-control"
                                    placeholder="Last name"
                                    type="text"
                                    validate={{
                                      //pattern: { value: '^[a-zA-Z]+(([,. -][a-zA-Z ])?[a-zA-Z]*)*$', errorMessage: 'Last name can only contain aphanumeric and space' },
                                      pattern: { value: '^(?!\d+$)(?:[a-zA-Z0-9][a-zA-Z0-9 ]*)?$', errorMessage: 'Last name can only contain aphanumeric and space' },
                                      maxLength: { value: 30, errorMessage: 'Last name must not be greater than 30 characters.' }
                                    }}
                                    value={this.state.lastName}
                                    onChange={(event, value) => { this.setState({ lastName: value }) }}
                                  />
                                </div>
                              </Col>
                            </Row>

                            <Row>
                              <Col>
                                <Row>
                                  <Label htmlFor="basicpill-countryCode">
                                    Address
                                  </Label>
                                  <Col>
                                    <div className="mb-3">
                                      <AvField
                                        name="address1"
                                        type="text"
                                        placeholder="Address"
                                        validate={{
                                          required: { value: true, errorMessage: 'Please enter a address' },
                                          minLength: { value: 10, errorMessage: 'Address must have minimum 10 characters.' },
                                        }}
                                        value={this.state.address1}
                                        onChange={(event, value) => { this.setState({ address1: value }) }}
                                      />
                                    </div>
                                  </Col>
                                  <Col>
                                    <div className="mb-3">
                                      <AvField
                                        name="address2"
                                        type="text"
                                        placeholder="Address"
                                        value={this.state.address2}
                                        onChange={(event, value) => { this.setState({ address2: value }) }}
                                      />
                                    </div>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>

                            <Row>
                              <Col>
                                <div className="mb-3">
                                  <AvField
                                    name="city"
                                    label="City"
                                    type="text"
                                    placeholder="City"
                                    validate={{
                                      required: { value: true, errorMessage: 'Please enter a city' }
                                    }}
                                    value={this.state.city}
                                    onChange={(event, value) => { this.setState({ city: value }) }}
                                  />
                                </div>
                              </Col>
                              <Col>
                                <div className="mb-3">
                                  <AvField
                                    name="state"
                                    label="State"
                                    type="text"
                                    placeholder="State"
                                    validate={{
                                      required: { value: true, errorMessage: 'Please enter a state' }
                                    }}
                                    value={this.state.state}
                                    onChange={(event, value) => { this.setState({ state: value }) }}
                                  />
                                </div>
                              </Col>
                            </Row>

                            <Row>
                              <Col className="col-md-6">
                                <div className="mb-3">
                                  <AvField type="select" name="country" label="Country" onChange={this.handleCountry}
                                  >
                                    {countries.map((country, index) => (
                                      <option value={JSON.stringify(country)} key={index}>{country.name}</option>
                                    ))}
                                  </AvField>
                                </div>
                              </Col>

                              <Col>
                                <Row>
                                  <Label htmlFor="basicpill-countryCode">
                                    Mobile
                                  </Label>
                                  <Col md="4" className="pe-md-0 md-pe-3">
                                    <AvField type="text" name="mobilecode" placeholder="Code" value={this.state.countryCode}
                                      disabled
                                      validate={{
                                        required: { value: true, errorMessage: 'Please select a country code' }
                                      }}
                                    >
                                    </AvField>
                                  </Col>
                                  <Col md="" className="ps-md-0">
                                    <AvField
                                      name="mobile"
                                      type="text"
                                      placeholder="Mobile"
                                      validate={{
                                        required: { value: true, errorMessage: 'Please enter mobile.' },
                                        pattern: { value: '^[0-9]{8,10}$', errorMessage: 'Please enter a valid mobile.' }
                                      }}
                                      value={this.state.mobile}
                                      onChange={(event, value) => { this.setState({ mobile: value }) }}
                                    />
                                  </Col>
                                </Row>
                              </Col>
                            </Row>

                            <Row>
                              <Col>
                                <div className="mb-3">
                                  <AvField
                                    name="aadharNumber"
                                    label="Aadhar Number"
                                    type="text"
                                    placeholder="Aadhar Number"
                                    value={this.state.aadharNumber}
                                    onChange={(event, value) => { this.setState({ aadharNumber: value }) }}
                                    validate={{
                                      pattern: { value: '^[0-9]{12}$', errorMessage: 'Please enter a valid 12 digit aadhar number' }
                                    }}
                                  />
                                </div>
                              </Col>

                              <Col>
                                <div className="mb-3">
                                  <AvField
                                    name="passportNumber"
                                    label="Passport Number"
                                    type="text"
                                    placeholder="Passport Number"
                                    maxLength="9"
                                    value={this.state.passportNumber}
                                    onChange={(event, value) => { this.setState({ passportNumber: value }) }}
                                    validate={{
                                      pattern: { value: '^[a-zA-Z0-9]{3,9}$', errorMessage: 'Please enter a valid 9 digit passport number' }
                                    }}
                                  />
                                </div>
                              </Col>

                            </Row>

                            <Row className="col-md-6">
                              <Col>
                                <div className="mb-3">
                                  <AvField
                                    name="email"
                                    label="Email"
                                    className="form-control"
                                    placeholder="Email"
                                    errorMessage="Please enter a vaild email"
                                    type="email"
                                    required
                                    value={this.state.email}
                                    onChange={(event, value) => { this.setState({ email: value }) }}
                                  />
                                </div>
                              </Col>
                            </Row>

                            <div className="text-end mt-4">
                              <button
                                className="btn btn-primary btn-block waves-effect waves-light"
                                type="submit"
                              >
                                Update
                              </button>
                            </div>
                          </AvForm>
                        </TabPane>
                        <TabPane
                          tabId="2"
                          id="v-pills-payment"
                          role="tabpanel"
                          aria-labelledby="v-pills-payment-tab"
                        >
                          <AvForm
                            className="needs-validation"
                            onValidSubmit={this.handleValidLoginUpdate}
                          >
                            <div>
                              <Alert color="info" className="mb-4" role="alert">
                                <h5 className="font-size-16 me-3">Login details</h5>
                              </Alert>
                            </div>
                            <Row>
                              <Col md="6">
                                <div className="mb-3">
                                  <AvField
                                    name="username"
                                    label="Username"
                                    type="text"
                                    placeholder="Username"
                                    validate={{
                                      required: { value: true, errorMessage: 'Please enter a username' },
                                      minLength: { value: 6, errorMessage: 'Username must have minimum 6 characters.' },
                                      maxLength: { value: 30, errorMessage: 'Username must not be greater than 30 characters.' },
                                    }}
                                    value={this.state.username}
                                    onChange={(event, value) => { this.setState({ username: value }) }}
                                    disabled
                                  />
                                </div>
                              </Col>
                            </Row>

                            <Row>
                              <Col md="6">
                                <div className="mb-3">
                                  <AvField
                                    name="password"
                                    label="Old password"
                                    type="password"
                                    placeholder="Old password"
                                    errorMessage="Enter Old password"
                                    value={this.state.password}
                                    validate={{
                                      required: { value: true, errorMessage: 'Please enter your old password' },
                                      minLength: { value: 6, errorMessage: 'Password must have minimum 6 characters.' },
                                      maxLength: { value: 30, errorMessage: 'Password must not be greater than 30 characters.' },
                                    }}
                                    onChange={(event, value) => {
                                      this.setState({ password: value })
                                    }}
                                  />
                                </div>
                              </Col>
                            </Row>


                            <Row>
                              <Col>
                                <div className="mb-3">
                                  <AvField
                                    name="newPassword"
                                    label="New password"
                                    type="password"
                                    placeholder="New password"
                                    errorMessage="Enter New password"
                                    value={this.state.newPassword}
                                    validate={{
                                      required: { value: true, errorMessage: 'Please enter your new password' },
                                      minLength: { value: 6, errorMessage: 'Password must have minimum 6 characters.' },
                                      maxLength: { value: 30, errorMessage: 'Password must not be greater than 30 characters.' },
                                    }}
                                    onChange={(event, value) => {
                                      this.setState({ newPassword: value })
                                    }}
                                  />
                                </div>
                              </Col>
                              <Col>
                                <div className="mb-3 ">
                                  <AvField
                                    name="confirmPassword"
                                    label="Confirm password"
                                    type="password"
                                    placeholder="Confirm password"
                                    value={this.state.confirmPassword}
                                    validate={{
                                      required: { value: true, errorMessage: 'Please confirm your password.' },
                                      match: { value: 'newPassword', errorMessage: 'New password and confirm password must be same.' }
                                    }}
                                  />
                                </div>
                              </Col>
                            </Row>

                            <div className="text-end mt-4">
                              <button
                                className="btn btn-primary btn-block waves-effect waves-light"
                                type="submit"
                              >
                                Update
                              </button>
                            </div>
                          </AvForm>
                        </TabPane>
                      </TabContent>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </div>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

UserProfile.propTypes = {
  editProfile: PropTypes.func,
  error: PropTypes.any,
  success: PropTypes.any,
  astroUser: PropTypes.object,
  actionResult: PropTypes.object,
}

const mapStateToProps = state => {
  const { error, success, astroUser, actionResult, loading } = state.Profile
  return { error, success, astroUser, actionResult, loading }
}

export default withRouter(
  connect(mapStateToProps, { editProfile, clearActionResult, getProfile })(UserProfile)
)
